import React, { useState } from 'react';

import SyncOutlinedIcon from '@mui/icons-material/SyncOutlined';
import { Button, CircularProgress } from '@mui/material';

interface Props {
  sx: object;
  onSync: () => Promise<void>;
}

export default function SyncImagesButton({ sx, onSync }: Props) {
  const [isSyncing, setIsSyncing] = useState(false);

  const handleClick = async () => {
    setIsSyncing(true);
    try {
      await onSync();
    } finally {
      setIsSyncing(false);
    }
  };

  return (
    <Button
      variant="text"
      startIcon={isSyncing ? <CircularProgress size={16} /> : <SyncOutlinedIcon />}
      sx={sx}
      disabled={isSyncing}
      onClick={handleClick}
    >
      Sync room images
    </Button>
  );
}
